import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {CollectionsService} from '../../service/collections.service';
import {Subscription} from 'rxjs';
import {CartService} from '../../../cart/services/cart.service';
import {map, take} from 'rxjs/operators';
import {ProductInterface} from '../../../products/interfaces/product.interface';
import i18next from 'i18next';
import {getCurrencySymbol} from '@angular/common';

@Component({
  selector: 'app-products-grid',
  templateUrl: './products-grid.component.html',
  styleUrls: ['./products-grid.component.scss']
})
export class ProductsGridComponent implements OnInit {
  collectionId: string;
  productsData: ProductInterface[] | undefined;
  priceActive = false;
  dataLoaded = this.collectionsService.dataLoaded;
  lang!: string;
  currencySymbol!: string;
  private subscriptions: Subscription = new Subscription();

  constructor(private activatedRoute: ActivatedRoute,
              public collectionsService: CollectionsService,
              private cartService: CartService) {
    this.collectionId = this.activatedRoute.snapshot.params.id;

    this.collectionsService.loadDataSub.pipe(
      take(1),
      map((item: any) => {
        this.serveData();
      })
    ).subscribe();
  }

  ngOnInit(): void {
    if (this.dataLoaded) {
      this.serveData();
    }
  }

  serveData(): void {
    this.currencySymbol = getCurrencySymbol(this.collectionsService.currencyCode, 'narrow');
    this.lang = i18next.language;
    console.log(this.lang);
    this.productsData = this.collectionsService.getProductsDataFromCollection(this.collectionId).sort((a, b) => {
      return a.sku - b.sku;
    });

    const priceActiveSub = this.cartService.priceActive$.subscribe((value) => {
      this.priceActive = value;
    });
    this.subscriptions.add(priceActiveSub);
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  addTocart($event: MouseEvent, product: ProductInterface): void {
    $event.stopImmediatePropagation();
    this.cartService.addToCart(product, this.collectionId, 1);
  }
}
